'use strict';
import { cloneDeep } from 'lodash';
import { CropDialogModel } from "./cropDialogModel";

export class PatientImportDocumentDialogModel {
  isCancelled = false;
  isEmpty = false;
  isImage = false;
  resultFile = null;
  originalFileUrl = null;

  constructor(isIOSDevice, title, data) {
    this.isIOSDevice = isIOSDevice;
    this.title = title.toUpperCase();
    this.scope = null;
    this.data = cloneDeep(data);
    if (this.data.file.originalFile && this.data.file.originalFile.type && this.data.file.originalFile.type.includes("image/")){
      this.isImage = true;
    }

    this.fileName = this.data.file && this.data.file.name || this.data.file.originalFile && this.data.file.originalFile.name;
    this.originalFileUrl = URL.createObjectURL(this.data.file.originalFile || this.data.file);
  }

  init(modal, scope, modalService, ionicDatePicker) {
    this.scope = scope;
    this.modalInstance = modal;
    this.modalService = modalService;
    this.ionicDatePicker = ionicDatePicker;

    let currentDate = new Date();
    let month = currentDate.getMonth() + 1;
    let day = currentDate.getDate();
    let year = currentDate.getFullYear();
    this.data.date = month + '/' + day + '/' + year;

  }

  async onEdit(){
    const cropModel = new CropDialogModel().loadFromExistingData(cloneDeep(this.data.file), this.isIOSDevice);
    const cropResponse = await this.modalService.showDialogWindow('views/templates/cropDialog.html', cropModel, true);
    if (!cropResponse.isCancelled){
      this.data.file = cropResponse.file;
    }
  }

  changeDate(data, field) {
    const val = data[field];

    const minDate = new Date(1900, 1, 1);
    const maxDate = new Date();

    const ipObj = {
      callback: function (val) {
        let date = new Date(val);
        if (date > maxDate) {
          date = maxDate;
        }
        else if (date < minDate) {
          date = minDate;
        }
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        data[field] = month + '/' + day + '/' + year;
      },
      inputDate: !val || val === '/  /' || val === '//' ? new Date() : new Date(val),
      from: minDate,
      to: maxDate
    };

    this.ionicDatePicker.openDatePicker(ipObj);
  }

  async closeWindow() {
    const confirmed = await this.modalService.showConfirmation(null, 'Are you sure you want to cancel?');
      if (confirmed) {
        this.isCancelled = true;
        this.modalInstance.remove();
      }
      return;
  }

  remove(){
    this.data.file = null;
    this.fileName = null;
  }

  upload(){
    let input = document.getElementById('image-upload-input');
    if (input){
      document.body.removeChild(input);
    }

    input = document.createElement('input');
    input.id = 'image-upload-input';
    input.type = 'file';
    input.accept = 'image/*, application/pdf';
    input.multiple = false;
    const self = this;
    input.onchange = ($event) => this.onFileUploaded($event, self);

    document.body.appendChild(input);
    input.click();
  }

  async onFileDroped($event){
    $event.preventDefault();
    const file = $event.originalEvent.dataTransfer.files[0];
    this.openCropDialog(file, this);
  }

  onDragOver($event){
    $event.preventDefault();
    $event.originalEvent.dataTransfer.dropEffect = "move";
    $event.originalEvent.dataTransfer.setData("text", $event.target.id);
  }

  async onFileUploaded($event, self){
    if (!$event || !$event.target || !$event.target.files || !$event.target.files.length){
      return;
    }

    const file = $event.target.files[0];
    if (!file || !file.type.includes('image/') && !file.type.includes('application/pdf') && !file.type.includes('text/plain')){
      await this.modalService.showErrorMessage(`Uploaded file type - ${file.type} is not supported. Supported types: image, PDF, txt`);
      return;
    }
  
    if (file.type.includes("image/")){
      await this.openCropDialog(file, self);
    }
    else {
      this.data.file = file;
      this.originalFileUrl = URL.createObjectURL(this.data.file);
      this.fileName = this.data.file.name;
    }
  }

  async openCropDialog(file, self){
    const cropModel = new CropDialogModel(file);
    const cropResponse = await this.modalService.showDialogWindow('views/templates/cropDialog.html', cropModel, true);
    if (!cropResponse.isCancelled){
      self.data.file = cropResponse.file;
      this.fileName = this.data.file && this.data.file.name || this.data.file.originalFile && this.data.file.originalFile.name;
      this.originalFileUrl = URL.createObjectURL(this.data.file.originalFile || this.data.file);
    }
  }

  fileClicked(){
    window.open(this.originalFileUrl, '_blank');
  }

  async save() {
    if (this.isEmpty) {
      this.modalService.showAlert('Please choose a file to upload.');
      return;
    }
    if (!this.data.date || this.data.date === '/  /' || this.data.date === '//') {
      this.modalService.showAlert('Date must be filled out.');
      return;
    }

    if (!this.data.file){
      this.modalService.showAlert('File must be selected.');
      return;
    }
    let date = new Date(this.data.date);
    if (date > new Date()) {
      this.modalService.showAlert('Please choose a valid date.');
      return;
    }

    if (!this.isImage) {
      this.data.resultFile = {
        file: {
          fileName: this.data.file.name,
          fileSize: this.data.file.size,
          fileType: this.data.file.type,
          lastModifiedTime: this.data.file.lastModifiedTime,
          lastModifiedDate: this.data.file.lastModifiedDate,
          fileAsBase64: '',
        },
        toUpload: new File([this.data.file], `${this.data.file.name}`)
      }
    }
    else {
      this.data.resultFile = {
        file: {
          fileName: this.data.file.originalFile.name,
          fileSize: this.data.file.croppedBlob.size,
          fileType: this.data.file.originalFile.type,
          lastModifiedTime: this.data.file.originalFile.lastModifiedTime,
          lastModifiedDate: this.data.file.originalFile.lastModifiedDate,
          fileAsBase64: '',
        },
        toUpload: new File([this.data.file.croppedBlob], `${this.data.file.originalFile.name}`)
      }
    }
    this.modalInstance.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/patientImportDocumentDialogModel.js